// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Warranty: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 38 46" enableBackground="new 0 0 38 46" xmlSpace="preserve">
<path fillRule="evenodd" clipRule="evenodd" d="M19,0.08L0.25,8.42v12.5c0,11.56,8,22.38,18.75,25
	c10.75-2.62,18.75-13.44,18.75-25V8.42L19,0.08z M14.83,33.42L6.5,25.08l2.94-2.94l5.4,5.38l13.73-13.73l2.94,2.96L14.83,33.42z"/>
</svg>;
};

export default React.memo(Warranty);
